'use client';

import { Box, Grid, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';

const stats = [
    { value: "10,000+", label: "value_1", color: "#F15859" },
    { value: "150+", label: "value_2", color: "#F15859" },
    { value: "4.8/5", label: "value_3", color: "#F15859" },
    { value: "95%", label: "value_4", color: "#F15859" },
];

const CumulativeStats = () => {

    const t = useTranslations('CaseStudiesPage.cumulative_states')

    return (
        <Box sx={{ textAlign: 'center', mt: 12, mb: 4 }}>
            <Typography variant="h4" component="h2" sx={{ fontWeight: 800, color: '#132c4b', mb: 8 }}>
                {t(`title`)} :
            </Typography>
            <Grid container spacing={4}>
                {stats.map((stat, index) => (
                    <Grid size={{ xs: 6, md: 3 }} key={index}>
                        <Box sx={{
                            backgroundColor: '#fef2f2', // Light red tint
                            borderRadius: '16px',
                            py: 4,
                            px: 2
                        }}>
                            <Typography variant="h4" component="p" sx={{ fontWeight: 800, color: stat.color, mb: 1 }}>
                                {stat.value}
                            </Typography>
                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#475569' }}>
                                {t(stat.label)}
                            </Typography>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default CumulativeStats;
